import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/terms/page.tsx");
